const CODE_END_SEGMENTS_COUNT = 2;

type LabelledSubMission = Readonly<{ code: string; typeCode?: string | null }>;

// A mission code is long (prefix, client, postal code, type, date, rank): a
// sub-mission is told apart by its type code, else by the end of its code.
const buildSubMissionShortLabel = ({ code, typeCode }: LabelledSubMission) =>
  typeCode ?? code.split('_').slice(-CODE_END_SEGMENTS_COUNT).join('_');

// The sub-missions sharing a label are numbered in their display order.
export const buildSubMissionShortLabels = (
  subMissions: readonly LabelledSubMission[],
): readonly string[] => {
  const labels = subMissions.map(buildSubMissionShortLabel);

  return labels.map((label, index) => {
    const sameLabelCount = labels.filter((other) => other === label).length;
    const rank = labels
      .slice(0, index + 1)
      .filter((other) => other === label).length;

    return sameLabelCount > 1 ? `${label} (${rank.toFixed()})` : label;
  });
};
